/* eslint-disable no-underscore-dangle */
import { useEffect, useContext } from 'react';

import { useMutation } from '@apollo/client';

import { GeneralContext } from '../../../../core/app-context/GeneralContext';
import { DELETE_CREDENTIALS_MEMPHIS } from './graphql';

export function useDeleteMemphisCredentials() {
  const { setLoading, setErrorMessage, setSuccessMessage } =
    useContext(GeneralContext);
  const [DeleteMemphisCredentials, { loading }] = useMutation(
    DELETE_CREDENTIALS_MEMPHIS,
    { fetchPolicy: 'network-only' },
  );

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  async function deleteMemphisCredentials(storeId) {
    try {
      const res = await DeleteMemphisCredentials({
        variables: { storeId },
      });
      const { code, message } = res.data.deleteMemphisCredentials;
      if (code === 200) {
        setSuccessMessage(message);
      } else {
        setErrorMessage(message);
      }
    } catch (e) {
      setErrorMessage(
        'Não foi possível deleter as credenciais Vtex, tente novamente mais tarde.',
      );
    }
  }

  return {
    deleteMemphisCredentials,
    loading,
  };
}
